import type { EnnismoreTheme } from '@/ui/theme';

import { delanoTheme } from './delano.theme';

export const delanoParisTheme: EnnismoreTheme = {
  ...delanoTheme,
  logoUrl: '/brands/delano/images/maison-delano-logo.svg',
};
